<template>
  <el-dialog title="岗位评级申请" :close-on-click-modal="false" :visible.sync="show" center @close="$emit('close')" width="520px">
    <el-form ref="ruleForm" label-width="180px" class="ruleForm">
      <el-form-item label="当前岗位等级：">
        <el-input size="medium" style="width:240px" clearable readonly />
      </el-form-item>
      <el-form-item class="formItemNormal" label="最新岗位等级：">
        <el-select filterable placeholder="请选择最新岗位等级" size="medium" style="width:240px" clearable>
          <el-option v-for="item in CommissionLevel" :key="item.ID" :label="item.Title" :value="item.Name" />
        </el-select>
      </el-form-item>
      <el-form-item class="warmReminder">
        <i class="el-icon-warning" /> 温馨提示：岗位评级需与线下评级一致
      </el-form-item>
      <el-form-item>
        <div class="submitBtn">
          <el-button size="medium" class="cancelWireless" @click="$emit('close')">取消</el-button>
          <el-button size="medium" type="primary" :loading='submitLoad' @click="submit">提交</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  name: "PostGradeDialog",
  props: ['show'],
  data() {
    return {
      submitLoad: false,
      CommissionLevel: this.$CommissionLevel
    }
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {

        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.ruleForm {
  padding: 16px 0;
  .formItemNormal {
    margin-bottom: 8px;
  }
  .warmReminder {
    :deep(.el-form-item__content) {
      line-height: normal;
      color: #f97024;
      font-size: 12px;
    }
  }
  .submitBtn {
    display: flex;
    :deep(.el-button) {
      width: 92px;
    }
    :deep(.el-button + .el-button) {
      margin-left: 16px;
    }
  }
}
</style>